import { Injectable } from '@angular/core';
import { SearchResourceType } from '@app/core/model/search/search-resource-type';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { SearchColumnFields, SearchGridOptionsFormatter } from '@app/search/gridOptions/search-grid-options-formatter';
import { HttpClient } from '@angular/common/http';
import { BiosampleLaunchFormChooserGridOptionsFormatter } from './biosample-launch-form-chooser-grid-options-formatter';
import { SampleLaunchFormChooserGridOptionsFormatter } from './sample-launch-form-chooser-grid-options-formatter';
import { ChooserGridOptionsFactoryService, IChooserGridOptionsFactoryService } from './chooser-grid-options-factory.service';

@Injectable({
  providedIn: 'root'
})
export class LaunchFormChooserGridOptionsFactoryService implements IChooserGridOptionsFactoryService {

  constructor(
    private resourceDictionaryService: SearchResourceDictionaryService,
    private bsshDatePipe: BsshDatePipe,
    private http: HttpClient,
    private defaultChooserFactory: ChooserGridOptionsFactoryService
  ) { }


  getGridOptionsFormatterForResource(resourceType: SearchResourceType): SearchGridOptionsFormatter<SearchColumnFields> {
    switch (resourceType) {
      case SearchResourceType.Biosample:
        return new BiosampleLaunchFormChooserGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.http);
      case SearchResourceType.Sample:
        return new SampleLaunchFormChooserGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.http);
      default:
        // For all other resource types, delegate to the default chooser factory
        return this.defaultChooserFactory.getGridOptionsFormatterForResource(resourceType);
    }
  }
}

